import { gql } from '@apollo/client';

/**
 * @deprecated Now we use MUTATION_UPDATE_RECORD_HEADER
 */
export const MUTATION_PROPERTIES_PANEL = gql`
    mutation UpdateRecordHeader($data: RecordHeaderUpdateInput!) {
        updateRecordHeader(data: $data) {
            id
            tenant {
                name
                id
            }
            recordType {
                id
                name
            }
            recordFile {
                id
            }
            statusId {
                id
                name
            }
            createdBy {
                id
                createdAt
                name
            }
            receivedBy {
                name
                id
            }
            approvedBy {
                name
                id
            }
            approvedAt
            assignedTo {
                id
                name
            }
            recordNumber
            enabled
            additionalFields {
                id
                tag
                value
            }
        }
    }
`;

export const MUTATION_UPDATE_USER_PREFERENCES = gql`
    mutation CreateOrUpdateUserPreferences($data: UserPreferencesInput!) {
        createOrUpdateUserPreferences(data: $data) {
            user {
                id
            }
            updatedAt
            tenant {
                id
            }
            preferenceData
            name
            isDefault
            id
            createdAt
            componentKey
        }
    }
`;
